// @ts-ignore
// eslint-disable-next-line
import PoiWorker from 'comlink-loader!./poi.worker';

export default PoiWorker;
